import purchaseOrder from '@js/store/modules/purchase-order';
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('purchaseOrder', ['hasFinalized', 'purchaseOrder']),

        isOrdered() {
            return this.purchaseOrder.status == 1;
        },

        isOpen() {
            return this.purchaseOrder.status == 0;
        },

        canView() {
            return this.can(this.permission.VIEW_PURCHASE_ORDER);
        },

        canUpdate() {
            return this.can(this.permission.SAVE_PURCHASE_ORDER);
        },

        canEdit() {
            return this.canUpdate && !this.hasFinalized;
        },

        canDelete() {
            return this.can(this.permission.DELETE_PURCHASE_ORDER);
        },

        statuses() {
            return {
                OPENED: 0,
                ORDERED: 1,
                RECEIVED: 2,
            };
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('purchaseOrder')) {
            this.$store.registerModule('purchaseOrder', purchaseOrder);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/purchase-order/purchase-order-mixin.js